const showMore = document.querySelector('.show-more-ingredients');
showMore.addEventListener('click', event => {
  const moreIngredients = document.querySelector('.more-ingredients');

  if (event.currentTarget.classList.contains('active')) {
    slideUp(moreIngredients, 500);
    event.currentTarget.classList.remove('active');
    event.currentTarget.querySelector('span').innerHTML = 'See More';
  } else {
    event.currentTarget.classList.add('active');
    slideDown(moreIngredients, 500);
    event.currentTarget.querySelector('span').innerHTML = 'See Less';
  }
});